<template>
	<div>
		<cart-item v-for="(product, key) in cartItemList" :key="key" :cart-item="product" :inCart="true">
		</cart-item>
	</div>
</template>
<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins';
import { mapWaitingActions, waitFor } from 'vue-wait';
import CartItem from '../cart/CartItem.vue'
export default {
	mixins: [webshopMixins],
	props: {
		prods: Array,
		cartItemList: Array,
	},
	// props: ['prods', 'cartItemList'],
	components: {
		CartItem
	},
	data() {
		return {
			fetchedDiscounts: [],
		};
	},

	methods: {
		...mapWaitingActions('clickAndCollect', {
			fetchDiscount: 'loading clickAndCollect fetchDiscount',
		}),
		cartItem(item) {
			return this.cartItemList.find((x) => x.id == item.id && x.isAdditionalProduct == item.isAdditionalProduct);
		},
		isDiscountValid(item) {
			return item && item.DiscountPrice != item.OriginalPrice;
		},
	},
	// watch: {
	// 	async cartItemList(val) {
	// 		if (val) {
	// 			waitFor(`loading clickAndCollect fetchDiscounts`, async function () {
	// 				await this.$store
	// 					.dispatch('clickAndCollect/fetchDiscounts', {
	// 						siteId: this.selectedSite,
	// 						chainId: parseInt(this.$route.params.chainId),
	// 						onlineSluttKundeId: this.$user.onlineSluttKundeId,
	// 						productItems: this.cartItemsBySiteId.map((x) => {
	// 							return {
	// 								Id: x.id,
	// 								Quantity: x.quantity,
	// 							};
	// 						}),
	// 					})
	// 					.then((x) => {
	// 						var discounts = [];
	// 						x.forEach((z) => {
	// 							if (!discounts.find((y) => y.ProductId == z.ProductId)) {
	// 								let same = x.filter(p => p.ProductId == z.ProductId && x.indexOf(p) != x.indexOf(z));
	// 								/**
	// 								 * Copy 'z' and mutate the copy instead to avoid mutating states outside mutation handlers
	// 								 */
	// 								var copy = Object.assign({}, z)
	// 								same.forEach(s => {
	// 									if (s) {
	// 										if (s.DiscountText != copy.DiscountText) {
	// 											copy.DiscountText = copy.DiscountText + "</br>" + s.DiscountText
	// 										}
	// 										copy.DiscountPrice = copy.DiscountPrice + s.DiscountPrice;
	// 										copy.OriginalPrice = copy.OriginalPrice + s.OriginalPrice;
	// 										copy.DiscountedQuantity = copy.DiscountedQuantity + s.DiscountedQuantity;
	// 									}
	// 								})
	// 								discounts.push(copy);
	// 							}
	// 						});
	// 						this.fetchedDiscounts = [...discounts];
	// 					});
	// 			}).apply(this);
	// 		}
	// 	},
	// },
	// async created() {
	// 	console.log(this.prods, this.cartItemList)
	// 	waitFor(`loading clickAndCollect fetchDiscounts`, async function () {
	// 		await this.$store
	// 			.dispatch('clickAndCollect/fetchDiscounts', {
	// 				siteId: this.selectedSite,
	// 				chainId: parseInt(this.$route.params.chainId),
	// 				onlineSluttKundeId: this.$user.onlineSluttKundeId,
	// 				productItems: this.cartItemsBySiteId.filter(x => !x.isAdditionalProduct).map((x) => {
	// 					return {
	// 						Id: x.id,
	// 						Quantity: x.quantity,
	// 					};
	// 				}),
	// 			})
	// 			.then((x) => {
	// 				this.fetchedDiscounts = [...x];

	// 			});
	// 	}).apply(this);
	// },
};
</script>